//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PracticeLogNotificationType, PracticeLogType } from './Enums';

export class PracticeLogNotificationInputItem extends ItemBase {
    PracticeLogID: string | null = null;
    RecipientProfileIDs: string[] = [];
    NotificationType: PracticeLogNotificationType = PracticeLogNotificationType.Added;
    readonly FeedbackType: PracticeLogType = PracticeLogType.Submission;

    constructor(initializer?: Partial<Omit<PracticeLogNotificationInputItem, "FeedbackType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PracticeLogNotificationInputItem";
}
